<template>
  <div
    class="bg-secondary position-relative basic-type issue"
    id="section-issue"
  >
    <img
      v-if="imageVisible"
      src="@/assets/image/background wave-2.png"
      class="position-absolute issue-wave"
    />
    <div
      v-if="imageVisible"
      class="wave-mask position-absolute start-0 top-0 w-100 h-100 bg-secondary"
    ></div>
    <div
      class="content container-xl text-primary text-center position-relative"
    >
      <TitleUnderline :title="'六大應用'"></TitleUnderline>
      <div class="row d-none d-md-flex">
        <div class="col-lg-4 col-md-6 mb-4" v-for="item in issue" :key="item.engTitle">
          <router-link :to="item.link">
            <div
              :style="{ backgroundImage: 'url(' + item.bgImg + ')' }"
              class="issue-card rounded-4 text-light d-flex flex-column justify-content-center align-items-center"
            >
              <div
                class="issue-mask rounded-4"
                :style="{
                  background: `linear-gradient(to right, ${item.deepColor}, ${item.lightColor})`,
                }"
              ></div>
              <div class="issue-icon rounded-circle mb-4">
                <img src="@/assets/image/circle icon.png" alt="" />
                <img :src="item.image" alt="" />
              </div>
              <h4 class="font-Noto-Sans-Bold">{{ item.title }}</h4>
              <p class="font-satoshi">{{ item.engTitle }}</p>
            </div>
          </router-link>
        </div>
      </div>
      <div
        id="carouselExampleDark"
        class="carousel slide carousel-fade d-block d-md-none"
        data-bs-ride="carousel"
      >
        <div class="carousel-inner">
          <div
            v-for="(item, index) in issue"
            :key="item.engTitle"
            :class="['carousel-item', { active: index === 0 }]"
            data-bs-interval="10000"
          >
            <router-link :to="item.link">
              <div
                :style="{ backgroundImage: 'url(' + item.bgImg + ')' }"
                class="issue-card rounded-4 text-light d-flex flex-column justify-content-center align-items-center"
              >
                <div
                  class="issue-mask rounded-4"
                  :style="{
                    background: `linear-gradient(to right, ${item.deepColor}, ${item.lightColor})`,
                  }"
                ></div>
                <div class="issue-icon rounded-circle mb-4">
                  <img src="@/assets/image/circle icon.png" alt="" />
                  <img :src="item.image" alt="" />
                </div>
                <h4 class="font-Noto-Sans-Bold">{{ item.title }}</h4>
                <p class="font-satoshi">{{ item.engTitle }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <button
          class="carousel-control-prev carousel-btn"
          type="button"
          data-bs-target="#carouselExampleDark"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="carousel-control-next carousel-btn"
          type="button"
          data-bs-target="#carouselExampleDark"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import securityIcon from "@/assets/image/security-icon(light).png";
import securityBanner from "@/assets/image/security banner.png";
import cloudIcon from "@/assets/image/cloud-icon(light).png";
import cloudBanner from "@/assets/image/cloud banner.png";
import storageIcon from "@/assets/image/storage-icon(light).png";
import storageBanner from "@/assets/image/storage banner.png";
import AIIcon from "@/assets/image/AI-icon(light).png";
import AIBanner from "@/assets/image/AI banner.png";
import K8sIcon from "@/assets/image/K8s-icon(light).png";
import K8sBanner from "@/assets/image/K8s banner.png";
import ITIcon from "@/assets/image/IT-icon(light).png";
import ITBanner from "@/assets/image/IT banner.png";

import { scrollMixin } from "@/mixins/scrollMixin";

export default {
  mixins: [scrollMixin],
  data() {
    return {
      issue: [
        {
          image: securityIcon,
          bgImg: securityBanner,
          title: "資訊安全",
          engTitle: "Security",
          link: "/campaign/issues/security",
          deepColor: "#8CC152",
          lightColor: "#A0D468",
        },
        {
          image: cloudIcon,
          bgImg: cloudBanner,
          title: "雲端服務",
          engTitle: "Cloud Service",
          link: "/campaign/issues/cloud-service",
          deepColor: "#3BAFDA",
          lightColor: "#4FC1E9",
        },
        {
          image: storageIcon,
          bgImg: storageBanner,
          title: "儲存與備份系統",
          engTitle: "Storage / Backup",
          link: "/campaign/issues/storage-and-backup",
          deepColor: "#AC92EC",
          lightColor: "#967ADC",
        },
        {
          image: AIIcon,
          bgImg: AIBanner,
          title: "AI大數據",
          engTitle: "AI / Big Data",
          link: "/campaign/issues/ai-big-data",
          deepColor: "#E9573F",
          lightColor: "#FC6E51",
        },
        {
          image: K8sIcon,
          bgImg: K8sBanner,
          title: "K8s與虛擬化",
          engTitle: "K8s / Virtualization",
          link: "/campaign/issues/k8s-and-virtualization",
          deepColor: "#F6BB42",
          lightColor: "#FFCE54",
        },
        {
          image: ITIcon,
          bgImg: ITBanner,
          title: "IT管理與效能監控",
          engTitle: "IT Management",
          link: "/campaign/issues/it-management",
          deepColor: "#48CFAD",
          lightColor: "#37BC9B",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.issue {
  overflow: hidden;
  z-index: 1;

  .carousel-btn {
    z-index: 8;
  }

  .issue-wave {
    left: -16%;
    top: -3%;
    width: 130%;
    height: 300px;
    object-fit: cover;
    z-index: 2;
  }
  .wave-mask {
    animation: right-to-left 1.5s forwards;
    z-index: 3;
  }

  @keyframes right-to-left {
    from {
      transform: translateX(0%);
    }
    to {
      transform: translateX(-100%);
    }
  }

  .content {
    z-index: 4;
  }
}

.issue-card {
  position: relative;
  height: 450px;
  background-position: center;
  background-size: cover;
  z-index: 4;

  h4 {
    font-size: 1.5rem;
  }

  @media (max-width: $xxl) {
    height: 390px;
  }
  
  @media (max-width: $md) {
    height: 360px;

    h4 {
      font-size: 1.25rem;
    }
  }

  &:hover .issue-icon::before {
    opacity: 1;
  }

  .issue-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.4;
    transition: opacity 0.3s ease-in-out;
    z-index: 5;
  }

  &:hover .issue-mask {
    opacity: 0;
  }
  .issue-icon,
  h4,
  p {
    z-index: 6;
  }

  .issue-icon {
    width: 150px;
    height: 150px;
    background-color: #8ca2ba;
    position: relative;
    overflow: hidden;

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(to right, #4653a1, #3283c2);
      opacity: 0;
      transition: opacity 0.4s ease-in-out;
    }

    .issue-card:hover &::before {
      opacity: 1;
    }

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 7;
    }
  }
}
</style>
